import NavigationPath from "Areas/SharedFeatures/navigationPath";
import Button from "Components/button";
import classNames from "classnames";
import React, { useCallback, useMemo } from "react";
import locale from "./actionPanel.locale";
const SIZES = {
    NAVIGATION_PANEL_HEIGHT: 40,
    NAVIGATION_PANEL_ITEMS_HEIGHT: 28
};
const navigationStyle = {
    height: SIZES.NAVIGATION_PANEL_HEIGHT
};
export default function ActionPanel(props) {
    const path = useMemo(() => [
        {
            title: locale.SUMMARY_REPORT
        },
        {
            title: props.summaryReportName || "..."
        }
    ], [props.summaryReportName]);
    const handleGoBack = useCallback(() => {
        if (props.backUrlHash) {
            window.location.href = props.backUrlHash;
        }
    }, [props.backUrlHash]);
    if (!props.summaryReportId)
        return null;
    return (React.createElement("div", { style: navigationStyle, className: classNames("border-bottom-gray-100 grid-cols-auto justify-content-space-between pl-0_75 pr-sm w-100-max", props.className) },
        React.createElement(NavigationPath, { path: path, height: SIZES.NAVIGATION_PANEL_ITEMS_HEIGHT }),
        (props.backUrlHash || props.onSave) && (React.createElement("div", null,
            props.backUrlHash && (React.createElement(Button, { className: "pt-0 pb-0 fz-14 text-light-on-primary-fixed", height: SIZES.NAVIGATION_PANEL_ITEMS_HEIGHT, icon: "icon-arrow-left-1 icon-size-14 text-light-on-primary-fixed", text: locale.BACK, onClick: handleGoBack })),
            props.onSave && (React.createElement(Button, { className: classNames("pt-0 pb-0 font-small btn-primary", props.backUrlHash && "ml-1"), height: SIZES.NAVIGATION_PANEL_ITEMS_HEIGHT, text: locale.SAVE, onClick: props.onSave }))))));
}
